import { returnErrors } from './errorAction';
import { GET_CANDIDATES_SUCCESS, UPLOAD_CANDIDATES_SUCCESS, GET_CANDIDATE_PROFILE_SUCCESS, SET_VOICE_SESSION_DATA, CANDIDATE_LOADING, SET_ASSESSMENT_INVITE_DETAILS, CLEAR_CANDIDATE_LIST, SET_VIDEO_SESSION_DATA, GET_PREQUALIFYING_REPORT, GET_LIST_CANDIDATES_SUCCESS, CLEAR_LIST_CANDIDATES } from '../Types/types';
import { getJobApiCall, postJobApiCall, deleteJobApiCall, putJobApiCall, getJobApiBlobCall, patchJobApiCall, postJobApiBlobCall } from '../../utils/jobRequest';
import { getApiCall, handle403Logout, postApiCall } from '../../utils/request';

export const fetchCandidatesByJobId = (jobId, queryParams = "") => async (dispatch) => {
  try {
    let baseUrl = `jobs/${jobId}/job-candidates`;
    const connector = queryParams ? "&" : "";
    const finalQuery = `${queryParams}${connector}`;
    const url = `${baseUrl}?${finalQuery}`;
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      dispatch({ type: GET_CANDIDATES_SUCCESS, payload: { data: response.data.data || [], pagination: response.data.pagination || { total: 0, page: 1, page_size: 10 }, } });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: GET_CANDIDATES_SUCCESS, payload: [] });
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

// Upload CSV
// `alreadyApplied` (optional): when defined, sent as the `already_applied` form
// flag — true = add straight to job candidates, false = invite + email flow.
// Left undefined by legacy callers so backend keeps its own default.
export const uploadCsvCandidateFile = (jobId, file, alreadyApplied) => async (dispatch) => {
  try {
    const formData = new FormData();
    // formData.append("file", file);
    if (!(file instanceof File)) {
      console.error("Invalid file type: ", file);
      return { success: false, message: "Invalid file format." };
    }

    formData.append("file", file, file.name);
    if (alreadyApplied !== undefined) {
      formData.append("already_applied", alreadyApplied ? "true" : "false");
    }

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/upload-csv`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CANDIDATES_SUCCESS, payload: response.data.message });
      return { success: true, message: response.data.message, data: response.data.data };
    } else {
      // postJobApiCall returns the Axios error object on failure — data lives at response.response.data
      console.log('Action else message')
      const message =
        response?.response?.data?.detail ||
        response?.response?.data?.message ||
        response?.data?.detail ||
        response?.data?.message ||
        "Upload failed";
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    console.log('Action catch message')
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed";
    return { success: false, message };
  }
};


// Upload Resume (PDF)
// `alreadyApplied` (optional): when defined, sent as the `already_applied` form
// flag — true = add straight to job candidates, false = invite + email flow.
// `source` (optional): one of CANDIDATE_SOURCE, applied to every file. Backend
// only stores it when already_applied is true.
export const uploadPdfCandidateFile = (jobId, files, alreadyApplied, source) => async (dispatch) => {
  try {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files", file);
    });
    if (alreadyApplied !== undefined) {
      formData.append("already_applied", alreadyApplied ? "true" : "false");
    }
    if (source) {
      formData.append("source", source);
    }

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/upload-resumes`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CANDIDATES_SUCCESS, payload: response.data.message });
      return { success: true, message: response.data.message, data: response.data.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Resume upload failed";
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Resume upload failed";
    return { success: false, message };
  }
};




//candidate profile
export const fetchCandidateProfile = (jobId, candidateId) => async (dispatch) => {
  dispatch({ type: CANDIDATE_LOADING, payload: true });
  try {
    const response = await getJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`);
    if (response?.status === 200) {
      dispatch({ type: GET_CANDIDATE_PROFILE_SUCCESS, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      dispatch({ type: CANDIDATE_LOADING, payload: false });
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: CANDIDATE_LOADING, payload: false });
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

// Upload single candidate Resume
export const uploadSingleCandidateResume = (jobId, candidateId, file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/${candidateId}/upload-resume`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch(fetchCandidatesByJobId(jobId));
      return { success: true, message: response.data.message };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Upload failed.";
      return { success: false, message };
    }
  } catch (err) {
    handle403Logout(err);
    const message =
      err?.response?.data?.detail ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong during upload.";
    return { success: false, message };
  }
};


//delete candidate record
export const deleteCandidate = (jobId, candidateId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`);
    if (response?.status === 200) {
      dispatch(fetchCandidatesByJobId(jobId));
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

// Initiate voice call
export const initiateVoiceCall = (jobId, candidateId, assistantId) => async (dispatch) => {
  try {
    const body = { assistant_id: assistantId };
    const response = await postJobApiCall(`jobs/${jobId}/voice-call/initiate/${candidateId}`, body);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};


export const fetchVoiceCallSession = (voiceCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`voice-call-session/${voiceCallId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_VOICE_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

// fetching a time-limited playback url for a voice call recording
export const fetchVoiceCallRecording = (voiceCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`voice-call-session/${voiceCallId}/recording`);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data?.url };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return { success: false };
  }
};

//update candidate details
export const updateCandidateDetails = (jobId, candidateId, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`, payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//getting voice assistants
export const fetchVoiceAssistants = (languageId = "") => async (dispatch) => {
  try {
    let url = "voice-assistants";
    if (languageId) {
      url += `?language_id=${languageId}`;
    }
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//getting tts voices for dynamic voice assistant
export const fetchTtsVoices = (languageId = "") => async (dispatch) => {
  try {
    let url = "tts-voices/";
    if (languageId) {
      url += `?language_id=${languageId}`;
    }
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//sending assessment invite to candidate
export const sendAssessmentInvite = (payload) => async (dispatch) => {
  try {
    const response = await postApiCall('test/send-job-assessment-invite', payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};


//fetching candidate assessment details
export const fetchAssessmentInviteDetails = (inviteId) => async (dispatch) => {
  try {
    const response = await getApiCall(`candidate/get-invite?inviteId=${inviteId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_ASSESSMENT_INVITE_DETAILS, payload: response.data.invite });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

export const clearCandidateList = () => (dispatch) => {
  dispatch({ type: CLEAR_CANDIDATE_LIST });
};

//initiate video call
export const initiateVideoCall = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall('video-call/initiate', payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

// voice call details
export const fetchVideoCallDetails = (videoCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`video-call/${videoCallId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_VIDEO_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

export const clearCandidateSessionData = () => (dispatch) => {
  dispatch({ type: "SET_VOICE_SESSION_DATA", payload: null });
  dispatch({ type: "SET_VIDEO_SESSION_DATA", payload: null });
  dispatch({ type: "SET_ASSESSMENT_INVITE_DETAILS", payload: null });
};

//export candidates as csv
export const exportCandidatesAsCsv = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiBlobCall(`jobs/${jobId}/job-candidates/export`);
    if (response?.status === 200 && response.data instanceof Blob) {
      return { success: true, blob: response.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return { success: false, message: "Export failed or invalid file." };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return { success: false, message: "Export failed or invalid file." };
  }
};

// Bulk update hiring status
export const bulkUpdateHiringStatus = (jobId, payload) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/job-candidates/bulk-update-hiring-status`, payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//candidate pre screening report
export const getPreScreeningReport = (id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`candidate/${id}/jpq-candidate-report/`);
    if (response?.status === 200) {
      dispatch({ type: GET_PREQUALIFYING_REPORT, payload: response.data.data });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
}

// update voice call status
export const getVoiceSessionStatus = (voiceCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`voice-call-session/${voiceCallId}/status`);
    if (response?.status === 200) {
      dispatch({ type: SET_VOICE_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
}

//Create share link
export const createShareLink = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall("candidate-report-share/create", payload);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return { success: false, message: response?.data?.message };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//send report link in email
export const sendShareEmail = (payload) => async () => {
  try {
    const res = await postJobApiCall("candidate-report-share/share-email", payload);

    if (res?.status === 200) {
      return { success: true, data: res.data };
    }
    return { success: false, message: res.data?.message || "Failed to send invite" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//copied shared link validation
export const validateShareLink = (payload) => async () => {
  try {
    const response = await postJobApiCall("candidate-report-share/validate", payload);

    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { status: response?.status };
  } catch (error) {
    handle403Logout(error);
    return { status: error?.response?.status };
  }
};

//email shared link validation
export const validateEmailShareLink = (payload) => async () => {
  try {
    const response = await postJobApiCall("candidate-report-share/email/validate", payload);

    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { status: response?.status };
  } catch (error) {
    handle403Logout(error);
    return { status: error?.response?.status };
  }
};

export const getListCandidates = (folder_id, list_id, search, limit = 10, page = 1) => async (dispatch) => {
  try {
    let url = `candidates/search-advanced`;
    const body = {
      is_active: true,
      page_size: limit,
      page
    };
    if (search) body.search = search;
    if (folder_id) body.folder_id = folder_id;
    if (list_id) body.list_id = list_id;

    const response = await postJobApiCall(url, body);
    if (response?.status === 200) {
      dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: response.data.data || [] });
      return { success: true, data: response.data.data, pagination: response.data.pagination };
    } else {
      dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: [] });
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: [] });
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

export const clearListCandidates = () => (dispatch) => {
  dispatch({ type: CLEAR_LIST_CANDIDATES });
};

// Get folders by company_id
export const getFolders = (company_id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`folders`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Get lists by folder_id (and name as query param)
export const getListsByFolder = (folder_id, name) => async (dispatch) => {
  try {
    let url = 'lists';
    const params = [];
    params.push(`page_size=${1000}`)
    if (folder_id) params.push(`folder_id=${folder_id}`);
    if (name) params.push(`name=${name}`);
    if (params.length) url += `?${params.join('&')}`;

    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Create a new folder
export const createFolder = (body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`folders/`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data || response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Folder creation failed';
      return { success: false, message, status: response?.status };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || 'Folder creation failed', status: error?.response?.status };
  }
};

// Create a new list
export const createList = (body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`lists`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data || response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'List creation failed';
      return { success: false, message, status: response?.status };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || 'List creation failed', status: error?.response?.status };
  }
};

// Dump candidates into a list
export const dumpCandidatesToList = (list_id, candidate_ids) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`lists/${list_id}/candidates/dump`, { candidate_ids });
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, message: response.data?.message || 'Candidates moved successfully' };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Move failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Move failed';
    return { success: false, message };
  }
};

// Agent query - smart search
export const agentQuery = (query) => async (dispatch) => {
  try {
    const response = await postJobApiCall('agent/query', { query });
    if (response?.status === 200) {
      return { success: true, data: response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Query failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Query failed';
    return { success: false, message };
  }
};

// Search advanced with raw payload (used for infinite scroll after agent/query)
export const searchAdvancedWithPayload = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall('candidates/search-advanced', payload);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || [], pagination: response.data.pagination };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Upload candidate resumes (with optional folder_id, list_id as query params)
export const uploadCandidateResumes = (folder_id, list_id, files) => async (dispatch) => {
  try {
    // Support calling as uploadCandidateResumes(files) without folder/list
    let actualFolderId = folder_id;
    let actualListId = list_id;
    let actualFiles = files;
    if (Array.isArray(folder_id) && list_id === undefined && files === undefined) {
      actualFiles = folder_id;
      actualFolderId = null;
      actualListId = null;
    }

    const formData = new FormData();
    actualFiles.forEach((file) => {
      formData.append('files', file);
    });

    const params = [];
    if (actualFolderId) params.push(`folder_id=${actualFolderId}`);
    if (actualListId) params.push(`list_id=${actualListId}`);
    const url = params.length ? `candidates/upload-resumes?${params.join('&')}` : `candidates/upload-resumes`;

    const response = await postJobApiCall(url, formData);

    if (response?.status === 200 || response?.status === 201) {
      return { success: true, message: response.data.message || 'Uploaded successfully', data: response.data.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Upload failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Upload failed';
    return { success: false, message };
  }
};

// Add global candidates to a job
// `source` (optional): one of CANDIDATE_SOURCE, applied to every candidate added.
export const addFromGlobalCandidates = (jobId, candidateIds, source) => async (dispatch) => {
  try {
    const body = { global_candidate_ids: candidateIds };
    if (source) body.source = source;
    const response = await postJobApiCall(`jobs/${jobId}/job-candidates/add-from-global-candidates`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, message: response.data.message || 'Candidates added successfully' };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Failed to add candidates';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Failed to add candidates';
    return { success: false, message };
  }
};

// ─── Candidate Invites (InviteCandidatesV2 workspace) ──────────────────────
// Backing the standalone /jobs/:jobId/invite page. These are additive and do
// not touch the existing job-candidates flows.

const normalizeInviteError = (respOrErr, fallback) =>
  respOrErr?.response?.data?.detail ||
  respOrErr?.response?.data?.message ||
  respOrErr?.data?.detail ||
  respOrErr?.data?.message ||
  respOrErr?.message ||
  fallback;

// GET list of invites + job-wide summary. `status_id` filters the list only,
// summary counts stay job-wide.
export const fetchCandidateInvites = (jobId, { statusId, page = 1, pageSize = 20 } = {}) => async (dispatch) => {
  try {
    const params = [];
    if (statusId) params.push(`status_id=${encodeURIComponent(statusId)}`);
    params.push(`page=${page}`);
    params.push(`page_size=${pageSize}`);
    const response = await getJobApiCall(`jobs/${jobId}/candidate-invites/?${params.join('&')}`);
    if (response?.status === 200) {
      const payload = response.data?.data || response.data || {};
      return {
        success: true,
        invites: payload.invites || [],
        summary: payload.summary || { invited: 0, applied: 0, no_response: 0, re_invited: 0, total: 0 },
        pagination: response.data?.pagination || payload.pagination || null,
      };
    }
    return { success: false, message: normalizeInviteError(response, 'Failed to load invites') };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: normalizeInviteError(error, 'Failed to load invites') };
  }
};

// POST send invites for a Smart Search selection. Body: { global_candidate_ids }.
export const sendCandidateInvites = (jobId, globalCandidateIds) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/candidate-invites/`, { global_candidate_ids: globalCandidateIds });
    if (response?.status === 200 || response?.status === 201) {
      const payload = response.data?.data || response.data || {};
      return {
        success: true,
        invitesCreated: payload.invites_created ?? 0,
        emailsQueued: payload.emails_queued ?? 0,
        skipped: payload.skipped || [],
        invites: payload.invites || [],
        message: response.data?.message,
      };
    }
    return { success: false, message: normalizeInviteError(response, 'Failed to send invites') };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: normalizeInviteError(error, 'Failed to send invites') };
  }
};

// POST re-invite a single candidate (Invited / No Response, one re-invite per
// candidate, 72h after the first invite). Blocks come back as a 400 whose
// `detail` is user-facing. `email_sent: false` means nothing changed.
export const resendCandidateInvite = (jobId, inviteId) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/candidate-invites/${inviteId}/resend`, {});
    if (response?.status === 200 || response?.status === 201) {
      const payload = response.data?.data || response.data || {};
      return {
        success: true,
        emailSent: payload.email_sent !== false,
        invite: payload.invite || null,
        message: response.data?.message,
      };
    }
    return { success: false, message: normalizeInviteError(response, 'Failed to resend invite') };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: normalizeInviteError(error, 'Failed to resend invite') };
  }
};

// POST bulk re-invite. Body: { invite_ids }. Partial success: blocked invites
// come back in `skipped` with a `reason` instead of failing the request.
export const bulkResendCandidateInvites = (jobId, inviteIds) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/candidate-invites/resend`, { invite_ids: inviteIds });
    if (response?.status === 200 || response?.status === 201) {
      const payload = response.data?.data || response.data || {};
      return {
        success: true,
        reinvited: payload.reinvited ?? 0,
        skipped: payload.skipped || [],
        invites: payload.invites || [],
        message: response.data?.message,
      };
    }
    return { success: false, message: normalizeInviteError(response, 'Failed to re-invite candidates') };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: normalizeInviteError(error, 'Failed to re-invite candidates') };
  }
};

// GET hiring statuses used as invite status chips (Invited / Applied / No Response).
export const fetchInviteHiringStatuses = () => async (dispatch) => {
  try {
    const response = await getJobApiCall(`hiring-statuses/?type=job_candidate_invite`);
    if (response?.status === 200) {
      const data = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data) ? response.data : [];
      return { success: true, data };
    }
    return { success: false, data: [] };
  } catch (error) {
    handle403Logout(error);
    return { success: false, data: [] };
  }
};

export const uploadResumeStatus = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`resume-upload?job_id=${jobId}`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Upload failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message = error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Upload failed';
    return { success: false, message };
  }
}

// ─── Advanced Filter Actions ────────────────────────────────────────────────

const advancedFiltersBase = (jobId) => `jobs/${jobId}/job-candidates/advanced-filters`;

export const fetchAdvancedFilterConfig = (jobId) => async (dispatch) => {
  try {
    const [itemsRes, sortRes] = await Promise.all([
      getJobApiCall(`${advancedFiltersBase(jobId)}/`),
      getJobApiCall(`${advancedFiltersBase(jobId)}/sort-options`),
    ]);
    if (itemsRes?.status === 200) {
      const items = (itemsRes.data.data || []).sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
      const stageContext = sortRes?.data?.data?.stage_context || [];
      const sortOptions = sortRes?.data?.data?.options || [];
      return { success: true, items, stageContext, sortOptions };
    }
    return { success: false, items: [], stageContext: [], sortOptions: [] };
  } catch (error) {
    handle403Logout(error);
    return { success: false, items: [], stageContext: [], sortOptions: [] };
  }
};

export const fetchFilterSubitems = (jobId, filterKey, params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    if (params.search) q.set('search', params.search);
    if (params.limit != null) q.set('limit', String(params.limit));
    if (params.offset != null && params.offset > 0) q.set('offset', String(params.offset));
    const qs = q.toString();
    const url = `${advancedFiltersBase(jobId)}/${filterKey}/subitems${qs ? `?${qs}` : ''}`;
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { success: false, data: null };
  } catch (error) {
    handle403Logout(error);
    return { success: false, data: null };
  }
};

export const searchCandidatesAdvanced = (jobId, payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`${advancedFiltersBase(jobId)}/search`, payload);
    if (response?.status === 200) {
      const candidates = response.data?.data?.candidates || response.data?.data || [];
      const pagination = response.data?.pagination || { total: 0, page: 1, page_size: 10 };
      dispatch({ type: 'GET_CANDIDATES_SUCCESS', payload: { data: candidates, pagination } });
      return { success: true };
    }
    dispatch({ type: 'GET_CANDIDATES_SUCCESS', payload: { data: [], pagination: { total: 0, page: 1, page_size: 10 } } });
    return { success: false };
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: 'GET_CANDIDATES_SUCCESS', payload: { data: [], pagination: { total: 0, page: 1, page_size: 10 } } });
    return { success: false };
  }
};

// ─── Activity-wise view (one row per candidate stage) ────────────────────────
// These return data instead of dispatching so they don't touch the Candidate-wise list.

const stageRowsBase = (jobId) => `jobs/${jobId}/job-candidates/stage-rows`;

export const searchCandidateStageRows = (jobId, payload) => async () => {
  try {
    const response = await postJobApiCall(`${stageRowsBase(jobId)}/search`, payload);
    if (response?.status === 200) {
      const data = response.data?.data;
      const rows = Array.isArray(data) ? data : (data?.rows || data?.items || data?.results || []);
      const pagination = response.data?.pagination || data?.pagination
        || { total: rows.length, page: payload?.page ?? 1, page_size: payload?.page_size };
      return { success: true, rows, pagination };
    }
    return { success: false, rows: [], pagination: { total: 0 } };
  } catch (error) {
    handle403Logout(error);
    return { success: false, rows: [], pagination: { total: 0 } };
  }
};

export const fetchStageRowRecruiters = (jobId) => async () => {
  try {
    const response = await getJobApiCall(`${stageRowsBase(jobId)}/recruiters`);
    if (response?.status === 200) {
      const data = response.data?.data;
      return { success: true, recruiters: Array.isArray(data) ? data : (data?.recruiters || data?.items || []) };
    }
    return { success: false, recruiters: [] };
  } catch (error) {
    handle403Logout(error);
    return { success: false, recruiters: [] };
  }
};

export const exportCandidatesAdvanced = (jobId, payload, format = 'xlsx') => async (dispatch) => {
  try {
    const response = await postJobApiBlobCall(
      `${advancedFiltersBase(jobId)}/search/export?format=${format}`,
      payload
    );
    if (response?.status === 200 && response.data instanceof Blob) {
      return { success: true, blob: response.data };
    }
    return { success: false, message: 'Export failed or invalid file.' };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.message || 'Export failed.' };
  }
};

export const fetchSavedSearches = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`${advancedFiltersBase(jobId)}/saved-searches`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || [] };
    }
    return { success: false, data: [] };
  } catch (error) {
    handle403Logout(error);
    return { success: false, data: [] };
  }
};

export const createSavedSearch = (jobId, body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`${advancedFiltersBase(jobId)}/saved-searches`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data };
    }
    const message = response?.data?.detail || response?.data?.message || 'Failed to save search';
    return { success: false, message };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.message || 'Failed to save search' };
  }
};

export const deleteSavedSearch = (jobId, searchId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`${advancedFiltersBase(jobId)}/saved-searches/${searchId}`);
    if (response?.status === 200 || response?.status === 204) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

export const getSavedSearchById = (jobId, searchId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`${advancedFiltersBase(jobId)}/saved-searches/${searchId}`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { success: false, data: null };
  } catch (error) {
    handle403Logout(error);
    return { success: false, data: null };
  }
};